import { useSelector } from "react-redux";
import Footer from "./Footer";
import Header from "./Header";
import CartModal from "./modals/CartModal";
import LoginModal from "./modals/LoginModal";
import ProductViewModal from "./modals/ProductViewModal";
import SearchModal from "./modals/SearchModal";
import WishListModal from "./modals/WishListModal";
import ScrollToTop from "./ScrollToTop";
import { themes } from "../utils/constants";
import { appTheme } from "../utils/constants";
import { getFromLocalStorage } from "../utils/localStorageUtils";

const Layout = ({ children }) => {

    const theme = useSelector((state) => state.general.theme);
    const themeId = theme || getFromLocalStorage(appTheme) || 1;
    const currentTheme = themes.find(t => t.id === themeId) || themes[0];
    const themeClassName = currentTheme.className;

    return (
        <>
            {/* ============================================================== */}
            {/* Preloader - style you can find in spinners.css */}
            {/* ============================================================== */}
            <div className="preloader" />
            {/* ============================================================== */}
            {/* Main wrapper - style you can find in pages.scss */}
            {/* ============================================================== */}
            <div id="main-wrapper" className={themeClassName}>

                <Header />
                <main>{children}</main>
                <Footer />

                {/* Modals */}
                <ProductViewModal />
                <LoginModal />
                <SearchModal />
                <WishListModal />
                <CartModal />

                {/* Scroll to Top */}
                <ScrollToTop />
            </div>
            {/* ============================================================== */}
            {/* End Wrapper */}
            {/* ============================================================== */}

        </>
    );
};

export default Layout;
